// extracted by css-extract-rspack-plugin
module.exports =  {"popupImage":"B7aGd","bannerSlider":"MtdCt","noMarginTop":"R08Ey","sliderBlk":"VWrqw","withborder":"EYQCZ","fakeLink":"KPZBT"};